const version='1.2.3'; const hash='9b33098'; export {version, hash};
